module.exports = __webpack_public_path__ + "media/images/pages/primary-teachers/stem-card-c8133362c8b9200a2f0b3a2b4d97bc07.svg";